// Helpers para rutas de visita.
// Centraliza el cálculo de "próxima visita" para que la pantalla de
// inicio y la lista de rutas siempre muestren la misma fecha.

const DIAS_SEMANA = {
  domingo: 0,
  lunes: 1,
  martes: 2,
  miercoles: 3,
  jueves: 4,
  viernes: 5,
  sabado: 6,
};

/**
 * Acepta `dias_visita` como string JSON (formato del backend) o como array.
 * Devuelve un Set con los números de día (0–6).
 */
export function parseDiasVisita(diasVisita) {
  if (!diasVisita) return new Set();
  let arr = diasVisita;
  if (typeof arr === 'string') {
    try { arr = JSON.parse(arr); } catch { return new Set(); }
  }
  if (!Array.isArray(arr)) return new Set();
  const nums = arr
    .map(d => DIAS_SEMANA[String(d).toLowerCase()])
    .filter(n => n !== undefined);
  return new Set(nums);
}

/**
 * Próxima visita programada a partir de hoy, en formato YYYY-MM-DD.
 * Si hoy mismo es día programado, devuelve hoy.
 * Devuelve null si no hay días programados válidos.
 */
export function calcularProximaVisita(diasVisita, ahora = new Date()) {
  const set = parseDiasVisita(diasVisita);
  if (set.size === 0) return null;

  const diaHoy = ahora.getDay();
  for (let offset = 0; offset < 7; offset++) {
    const candidato = (diaHoy + offset) % 7;
    if (set.has(candidato)) {
      const fecha = new Date(ahora);
      fecha.setDate(ahora.getDate() + offset);
      const y = fecha.getFullYear();
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      const d = String(fecha.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    }
  }
  return null;
}

export function esVisitaHoy(diasVisita, ahora = new Date()) {
  const set = parseDiasVisita(diasVisita);
  return set.has(ahora.getDay());
}
